export default __webpack_public_path__ + "static/media/shadow-soft-autumn.8a3993b6.png";